"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subscribe = void 0;
/* eslint-disable @typescript-eslint/no-namespace */
var EVENT_SYMBOL = '$$FIVE_EVENT$$';
function __generateEventIfNotExisted(instance) {
    if (!instance[EVENT_SYMBOL]) {
        instance[EVENT_SYMBOL] = {};
    }
    return instance[EVENT_SYMBOL];
}
function __removeEventIfNotExisted(instance) {
    if (!instance[EVENT_SYMBOL]) {
        delete instance[EVENT_SYMBOL];
    }
}
/**
 * 监听者模式
 * @template T 预设的监听回调类型
 * @example
 * ```
 * new Subscribe<{
 * "foo": [arg1: number, arg2: string],
 * "bar": [arg: boolean],
 * }>()
 * ```
 */
var Subscribe = /** @class */ (function () {
    function Subscribe() {
    }
    /**
     * 判断是否注册了事件
     * @param name  事件类型
     */
    Subscribe.prototype.hasListener = function (name) {
        var events = __generateEventIfNotExisted(this);
        return events && events[name] && events[name].length > 0;
    };
    /**
     * 注册事件
     * @param  name    事件类型
     * @param  callback 事件回调函数
     * @param  once     是否只执行一次
     * @returns 解除事件
     * @template K 预设的监听事件名称
     * @template C 回调函数函数上下文
     */
    Subscribe.prototype.on = function (name, callback, once) {
        var _this = this;
        var events = __generateEventIfNotExisted(this);
        if (!events[name])
            events[name] = [];
        events[name].push([callback, once || false]);
        return function () { return _this.off(name, callback); };
    };
    /**
     * 注册事件(是否只执行一次)
     * @param  name     事件类型
     * @param  callback 事件回调函数
     * @returns 解除事件
     * @template K 预设的监听事件名称
     * @template C 回调函数函数上下文
     */
    Subscribe.prototype.once = function (name, callback) {
        return this.on(name, callback, true);
    };
    /**
     * 解除事件
     *
     * 如果 name 不传的话解除对应所有事件
     * 如果 name, callback 不传的话解除所有name的所有事件
     * @param  name     事件类型
     * @param  callback 事件回调函数
     * @template K 预设的监听事件名称
     */
    Subscribe.prototype.off = function (name, callback) {
        if (name === undefined) {
            __removeEventIfNotExisted(this);
            return;
        }
        var events = __generateEventIfNotExisted(this);
        if (!events[name])
            events[name] = [];
        if (callback === undefined) {
            events[name].length = 0;
            return;
        }
        var index = 0;
        for (; index < events[name].length; index++) {
            if (events[name][index][0] === callback)
                break;
        }
        if (index < events[name].length) {
            events[name].splice(index, 1);
        }
    };
    /**
     * 触发事件
     * @param  name  事件类型
     * @param  data  触发事件的数据
     * @returns canceled 是否被触发取消
     * @template K 预设的监听事件名称
     */
    Subscribe.prototype.emit = function (name) {
        var data = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            data[_i - 1] = arguments[_i];
        }
        var canceled = false;
        var events = __generateEventIfNotExisted(this);
        var event = events[name] || [];
        for (var _a = 0, _b = event.slice(); _a < _b.length; _a++) {
            var one = _b[_a];
            var callback = one[0], _c = one[1], once = _c === void 0 ? false : _c;
            var result = callback.apply(void 0, data);
            if (once)
                this.off(name, callback);
            if (result === false)
                canceled = true;
        }
        return canceled;
    };
    return Subscribe;
}());
exports.Subscribe = Subscribe;
//# sourceMappingURL=Subscribe.js.map